import React from 'react'
import PropTypes from 'prop-types'

const lineStyle = {
  fill: 'none',
  strokeWidth: 2,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  strokeMiterlimit: 10,
}

const PlusCircleIcon = ({ customClassName, width, height, fill, line, }) =>
  (<svg
    className={customClassName}
    width={width}
    height={height}
    aria-labelledby="Plus Circle"
    viewBox="0 0 50 50"
  >
    <title id="plus-circle-icon">Plus Circle</title>
    <g>
      <circle fill={fill} cx="25" cy="25" r="25" />
      <line stroke={line} style={lineStyle} x1="25" y1="13" x2="25" y2="38" />
      <line stroke={line} style={lineStyle} x1="37.5" y1="25" x2="12.5" y2="25" />
    </g>
  </svg>)

PlusCircleIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  fill: PropTypes.string,
  line: PropTypes.string,
  customClassName: PropTypes.string,
}

PlusCircleIcon.defaultProps = {
  width: 20,
  height: undefined,
  fill: 'white',
  line: 'blue',
  customClassName: '',
}

export default PlusCircleIcon



// WEBPACK FOOTER //
// ./src/components/icons/PlusCircle.js